export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e30d62e4940ecaa0e80c20569cd5f6087cfe1730&name=revalidateCommunity!'